<template>
  <div>
    <div v-if="employment">
      <h5 class="mt-0 mb-0 font-size-14 text-left">
        <span>{{ applicant.job_id.title }}</span>
        <span class="float-right text-muted font-size-12">{{ applicant.date_applied | custom_date}}</span>
      </h5>
      <p class="mt-1 mb-0 text-left">
        Client: <span class="text-muted">{{ applicant.job_id.company_id.name }}</span><span class="text-muted">{{!applicant.job_id ? 'N/A' : `${applicant.job_id.company_id.name} | Uploaded by: ${applicant.user && applicant.user.company ? applicant.user.company_name + ' - ' + applicant.user.full_name : applicant.user.parent_id ? applicant.user.parent_id && applicant.user.parent_id.company ? applicant.user.parent_id.company_name + ' - ' + applicant.user.full_name : 'Individual - ' + applicant.user.full_name : 'Individual - ' + applicant.user.full_name}`}}</span> 
      </p>
    </div>
    <div>
      <div
        class="text-danger small"
        v-if="statusName == 'Rejected' || statusName == 'declined_consent'"
        v-b-tooltip.hover.v-danger.html	 :title="reason">
        <b-progress class="mt-1 progress-sm" v-if="statusOnly == false">
          <b-progress-bar
            value=100
            variant="danger"
          ></b-progress-bar>
        </b-progress>
        <div :class="statusOnly == true ? 'text-large' : 'small'"> {{statusName.toUpperCase().replace(/_/g, ' ')}}</div>
        <div>{{statusName == 'Rejected' ? '(hover to see description)' : ''}}</div>
      </div>

      <div v-if="statusName != 'Rejected' && statusName != 'declined_consent'">
        <b-progress class="mt-1 progress-sm" :max="100"  v-if="statusOnly == false">
          <b-progress-bar
            class="mr-2"
            value=20
            :variant="value >= 20 ? variant : 'soft-secondary'"
          ></b-progress-bar>

          <b-progress-bar
            class="mr-2"
            value=20
            :variant="value >= 40 ? variant : 'soft-secondary'"
          ></b-progress-bar>

          <b-progress-bar
            class="mr-2"
            value=20
            :variant="value >= 60 ? variant : 'soft-secondary'"
          ></b-progress-bar>

          <b-progress-bar
            class="mr-2"
            value=20
            :variant="value >= 80 ? variant : 'soft-secondary'"
          ></b-progress-bar>

          <b-progress-bar
            value=20
            :variant="value >= 100 ? variant : 'soft-secondary'"
          ></b-progress-bar>

        </b-progress>
        <div class="text-muted text-center text-warning pt-1" :class="statusOnly == true ? 'text-large' : 'small'">
          <span class="font-weight-bold">
            {{statusName}}
          </span>
          <div class="text-danger small" v-if="applicant.offer_declined">DECLINED</div>
          <div class="text-success small" v-if="applicant.offer_accepted">OFFER ACCEPTED</div>
          <div class="text-danger small" v-if="applicant.reschedule">RE-SCHEDULE</div>
          <div class="text-success small" v-if="applicant.confirmed_schedule && !applicant.offer_accepted">CONFIRMED SCHEDULE</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  data(){
    return {
      statusList:{
        'pending':0, 
        'sent':20, 
        'first interview':40, 
        'second interview':60, 
        'offered':80, 
        'placed':100
      },
      colorList:{
        0:'', 
        20:'warning', 
        40:'warning', 
        60:'warning', 
        80:'warning', 
        100:'warning'
      }
    }
  },
  computed:{
    value(){
      return this.statusList[this.$props.status.toLowerCase()]
    },
    variant() {
      return this.colorList[this.statusList[this.$props.status.toLowerCase()]]
    },
    statusName() {
      var status = this.$props.status
      if(status == 'second interview' && this.applicant.schedule_count > 2){
        status = status.replace(/second/g, this.getNumberWithOrdinal(this.applicant.schedule_count))
      }
      //{{statusName == 'second interview' ? '(' + getNumberWithOrdinal(applicant.schedule_count) + ')' : '' }}
      return status.toUpperCase().replace(/_/g, ' ')
    },
    application() {
      return this.$props.status
    },
  },
  props:{
    status:{
      default:'Pending'
    },
    'statusOnly':{
      type:Boolean,
      default:false
    },
    employment:{
      type:Boolean,
      default:false
    },
    reason:{
      default:''
    },
    applicant:{
      type:Object,
      default: function () {
        return {  }
      }
    }
  },
  methods:{
    getNumberWithOrdinal: function(n) {
      var s = ["TH", "ST", "ND", "RD"],
          v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }
  },
  filters: {
    date: function (value, format) {
      return moment(value).format(format || 'YYYY-MM-DD')
    },
    custom_date: function (value) {
      return moment(value).format('Mo MMMM YYYY')
    }
  }
}
</script>

<style lang="scss">
.text-large{
  font-size: 13px
}
</style>